var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileMagnifyingGlass = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-magnifying-glass",
    d: "M7.5,10a2,2,0,1,0-2,2A2,2,0,0,0,7.5,10Zm-.262,2.447a3,3,0,1,1,.709-.709l1.409,1.409a.5.5,0,1,1-.706.706L7.241,12.444ZM11,14V6H7.5A1.5,1.5,0,0,1,6,4.5V1H2A1,1,0,0,0,1,2V14a1,1,0,0,0,1,1h8A1,1,0,0,0,11,14Zm-.016-9a.477.477,0,0,0-.131-.231L7.231,1.147A.492.492,0,0,0,7,1.016V4.5a.5.5,0,0,0,.5.5ZM0,2A2,2,0,0,1,2,0H6.878A1.5,1.5,0,0,1,7.938.441l3.622,3.619A1.5,1.5,0,0,1,12,5.119V14a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2Z",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileMagnifyingGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-magnifying-glass.13dd753e3dc37a470e9b98ea3f191ca5.svg";